import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/AppLayout';

const StartMeeting = ({ roomId, setCallStarted, copySuccess, setCopySuccess }) => {
  const { t } = useTranslation();
  const roomLink = `${window.location.origin}${window.location.pathname}#/guest-video/${roomId}`;

  return (
    <AppLayout>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #fafbfc 0%, #f8fafc 100%)',
        }}
      >
        <div
          style={{
            background: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: 16,
            padding: '48px 56px',
            maxWidth: 480,
            width: '100%',
            textAlign: 'center',
            boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              background: 'rgba(128,0,32,0.08)',
              borderRadius: 16,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
            }}
          >
            <svg width='26' height='26' viewBox='0 0 24 24' fill='none' stroke='#800020' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
              <polygon points='23 7 16 12 23 17 23 7' />
              <rect x='1' y='5' width='15' height='14' rx='2' />
            </svg>
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', marginBottom: 8 }}>{t('screens.video.group.startTitle')}</div>
          <div
            style={{
              background: '#fff8e1',
              border: '1px solid #f59e0b',
              borderRadius: 8,
              padding: '10px 14px',
              marginBottom: 16,
              display: 'flex',
              alignItems: 'flex-start',
              gap: 8,
              textAlign: 'left',
            }}
          >
            <span style={{ fontSize: 16, lineHeight: 1 }}>⚠️</span>
            <span style={{ fontSize: 13, color: '#92400e', lineHeight: 1.5 }}>
              <strong>{t('screens.video.group.notJoinedWarnStrong')}</strong>{t('screens.video.group.notJoinedWarn')}<strong>{t('screens.video.group.startEmphasis')}</strong>{t('screens.video.group.notJoinedWarnEnd')}
            </span>
          </div>
          <div style={{ fontSize: 13, color: '#64748b', marginBottom: 24, lineHeight: 1.6 }}>{t('screens.video.group.cameraMicNote')}</div>
          <button
            onClick={() => setCallStarted(true)}
            style={{
              width: '100%',
              padding: '13px 0',
              background: '#800020',
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              fontSize: 15,
              fontWeight: 700,
              cursor: 'pointer',
              marginBottom: 20,
              letterSpacing: '0.01em',
            }}
          >
            {t('screens.video.group.startMeeting')}
          </button>
          <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 20 }}>
            <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 8 }}>{t('screens.video.group.meetingLinkNote')}</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <input
                readOnly
                value={roomLink}
                style={{
                  flex: 1,
                  fontSize: 12,
                  padding: '8px 10px',
                  border: '1px solid #e2e8f0',
                  borderRadius: 7,
                  background: '#f8fafc',
                  color: '#475569',
                  fontFamily: 'monospace',
                  outline: 'none',
                }}
              />
              <button
                onClick={() => {
                  navigator.clipboard?.writeText(roomLink).catch(() => {});
                  setCopySuccess(true);
                  setTimeout(() => setCopySuccess(false), 2500);
                }}
                style={{
                  padding: '8px 14px',
                  background: copySuccess ? '#10b981' : '#f1f5f9',
                  color: copySuccess ? '#fff' : '#475569',
                  border: 'none',
                  borderRadius: 7,
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                  whiteSpace: 'nowrap',
                }}
              >
                {copySuccess ? t('screens.video.group.copied') : t('screens.video.group.copy')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default StartMeeting;
